import dayjs from "dayjs";

export const normalizeFormFieldValue = (value) => {
  if (dayjs.isDayjs(value)) {
    return value.format('YYYY-MM-DD');
  }

  if (Array.isArray(value)) {
    return value.map(normalizeFormFieldValue);
  }

  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = normalizeFormFieldValue(value[key]);
      return acc;
    }, {} as any);
  }

  if (value === '') {
    return null;
  }

  return value;
};